import { render, staticRenderFns } from "./CardExibicaoNoticiasModeradas.vue?vue&type=template&id=e1984064&scoped=true"
import script from "./CardExibicaoNoticiasModeradas.vue?vue&type=script&lang=js"
export * from "./CardExibicaoNoticiasModeradas.vue?vue&type=script&lang=js"
import style0 from "./CardExibicaoNoticiasModeradas.vue?vue&type=style&index=0&id=e1984064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1984064",
  null
  
)

export default component.exports